import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "profile-container"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "left-username" }
const _hoisted_6 = { class: "left-slot" }
const _hoisted_7 = { class: "profile-slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mini-profile", { hoverable: _ctx.hoverable }])
  }, [
    _createVNode(_component_router_link, {
      to: "/profile",
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("div", {
          onClick: ($event: any) => (_ctx.goto(navigate, $event))
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }),
    (!_ctx.userID)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/auth",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_BaseButton, {
              class: "base-button-wrap auth-btn primary b-14 lg",
              onClick: navigate
            }, {
              left: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('../../assets/icons/steam.svg')
                }, null, 8, _hoisted_2)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.t('MiniProfile.signin')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.userID)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/profile",
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createVNode(_component_UserAvatar, {
                onClick: ($event: any) => (_ctx.goto(navigate, $event)),
                class: "user-avatar-wrap",
                avatar: _ctx.avatar,
                lvl: _ctx.lvl,
                userID: _ctx.id ? _ctx.id : _ctx.userID
              }, null, 8, ["onClick", "avatar", "lvl", "userID"])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/profile",
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.goto(navigate, $event)),
                class: "profile-left"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.username), 1),
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "left", {}, undefined, true)
                ])
              ], 8, _hoisted_4)
            ]),
            _: 3
          }),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "right", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}